var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuGeneralHeatingCoil1 = function SvgDAhuGeneralHeatingCoil1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "206,464 194,464 194,376 196,376 196,360 204,360 204,376 206,376",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 360,
    width: 1,
    height: 104,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 360,
    width: 2,
    height: 104,
    fill: "#DF1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204,464 203,464 203,360 204,360",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "194,448 199,453 199,455 194,460 168,460 168,448",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 457,
    width: 29,
    height: 1,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 453,
    width: 33,
    height: 2,
    fill: "#DF1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197,450 197,451 168,451 168,450",
    fill: "#787878"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 300,
    width: 32,
    height: 60,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,301v58h-30v-58H215 M216,300h-32v60h32V300L216,300z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 167.3,
    y: 329.5,
    transform: "matrix(0.4685 -0.8834 0.8834 0.4685 -185.2354 352.0671)",
    width: 65.3,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.7,306.8 191.8,306.8 191.8,303.8 190.4,303.8 190.4,306.8 187.6,306.8 187.6,308.2 190.4,308.2 190.4,311.2 191.8,311.2 191.8,308.2 194.7,308.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 408,
    x2: 200,
    y2: 380,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 393,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "200,395 207.1,407.5 192.9,407.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,396l6.3,11h-12.6L200,396 M200,394l-8,14h16L200,394L200,394L200,394z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "192.9,380.5 207.1,380.5 200,393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.3,381l-6.3,11l-6.3-11H206.3 M208,380h-16l8,14L208,380L208,380L208,380z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 394,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,384c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S173.5,384,179,384 M179,383c-6.1,0-11,4.9-11,11s4.9,11,11,11 s11-4.9,11-11S185.1,383,179,383L179,383z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181.4,391.1v5.7h-1V395l0.1-2.5l-1.7,4.4h-0.7l-1.7-4.4l0.1,2.5v1.9h-1v-5.7h1.3l1.6,4.4l1.6-4.4H181.4L181.4,391.1z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 421,
    width: 5.5,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 394,
    r: 4.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,390c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S197.8,390,200,390 M200,389c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5 S202.8,389,200,389L200,389z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 192.5,
    y: 408.5,
    width: 15,
    height: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,409v2h-14v-2H207 M208,408h-16v4h16V408L208,408z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 192.5,
    y: 432.5,
    width: 15,
    height: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,433v2h-14v-2H207 M208,432h-16v4h16V432L208,432z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 195.5,
    y: 411.5,
    width: 9,
    height: 21,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,412v20h-8v-20H204 M205,411h-10v22h10V411L205,411z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.9,432.2l-0.8-0.6c1.7-2.5,2.8-6.1,2.8-9.6s-1.1-7.1-2.8-9.6l0.8-0.6c1.8,2.7,2.9,6.5,2.9,10.2 S197.7,429.5,195.9,432.2L195.9,432.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.1,432.2c-1.8-2.7-2.9-6.5-2.9-10.1s1.1-7.5,2.9-10.2l0.8,0.6c-1.7,2.5-2.8,6.2-2.8,9.6s1,7,2.8,9.6L204.1,432.2 L204.1,432.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 411,
    width: 22,
    height: 22,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,412v20h-20v-20H189 M190,411h-22v22h22V411L190,411z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179,423.4l1.4-4.4h1.1l-2.1,5.7h-1l-2-5.7h1.1L179,423.4L179,423.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 407.4,
    transform: "matrix(3.839736e-03 -1 1 3.839736e-03 -229.6378 585.3745)",
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "174,433 172.6,438.4 173.5,438.4 173.5,443 174.5,443 174.5,438.4 175.4,438.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.4,438.4 184,433 182.6,438.4 183.5,438.4 183.5,443 184.5,443 184.5,438.4"
  }))))));
};
export default SvgDAhuGeneralHeatingCoil1;